<template>
    <div>
        <mt-command-bar :buttons="buttons" :moreButtons="moreButtons"></mt-command-bar>
        <img src="../assets/logo.png">
    </div>
</template>
<script>
    // import { CommandBar } from 'bh-mint-ui2';
    import utils from '../utils';

    export default {
        name :"emap-flow-toolbar", 
        data () {
            return {
                buttons: [
                    {name:"退回",id:"tuihui", type:"default", com_type:"chooseNode", method:""},
                    {name:"提交",id:"tijiao", type:"default", com_type:"none", method:""},
                    {name:"启动",id:"qidong", type:"primary", com_type:"none", method:"getFlowDefinition"}
                ],
                moreButtons: [
                    {name:"同意",id:"tongyi", type:"primary", com_type:"none", method:""},
                    {name:"终止",id:"tongyi", type:"primary", com_type:"none", method:""},
                    {name:"流程状态",id:"tongyi", type:"primary", com_type:"openurl", method:""}
                ]
            }
        },
        mounted() {
            // debugger;
            // utils.Get("./static/json/flow.json").then((data) => {
                // console.log(data)
            // });
        },
        methods: {
            getFlowDefinition() {
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// emap-flow-toolbar.vue?f16529b2